// Cart Drawer Functionality
var CartDrawer = function () {
  var settings = {
    speedOpen: 50,
    speedClose: 350,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-drawer-target]',
    selectorTrigger: '[data-drawer-trigger]',
    selectorClose: '[data-drawer-close]',
  };

  var toggleAccessibility = function (event) {
    event.setAttribute('aria-expanded', !(event.getAttribute('aria-expanded') === 'true'));
  };

  var openDrawer = function (trigger) {
    var target = document.getElementById(trigger.getAttribute('aria-controls'));
    target.classList.add(settings.activeClass);
    document.documentElement.style.overflow = 'hidden';
    toggleAccessibility(trigger);
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  };

  var closeDrawer = function (event) {
    var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"]');
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.style.overflow = '';
    toggleAccessibility(childrenTrigger);
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  var updateCartDrawer = function () {
    fetch('/?sections=cart_drawer')
      .then((resp) => resp.json())
      .then((data) => {
        document.getElementById('cart__drawer').innerHTML = data.cart_drawer;
        handleCartItemActions(); // Reattach event listeners after updating the content
        handleQuantityControls(); // Reattach quantity control event listeners
      });
  };

  var clickHandler = function (event) {
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);
    if (open) openDrawer(open);
    if (close) closeDrawer(close);
    if (open || close) event.preventDefault();
  };

  var keydownHandler = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      var drawers = document.querySelectorAll(settings.selectorTarget);
      drawers.forEach(function (drawer) {
        if (drawer.classList.contains(settings.activeClass)) {
          closeDrawer(drawer);
        }
      });
    }
  };

  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);
};

// Function to update the product quantity (replace this with your actual update logic)
var updateProductQuantity = function (productId, newQuantity) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: { [productId]: newQuantity } }),
  })
    .then((resp) => resp.json())
    .then((data) => {
      if (data.status === 'success') {
        updateCartDrawer();
      } else {
        console.error('Error updating product quantity:', data.message);
      }
    })
    .catch((error) => {
      console.error('Error updating product quantity:', error);
    });
};

// Handle Quantity Controls
var handleQuantityControls = function () {
  var quantityControls = document.querySelectorAll('.quantity-control');

  if (quantityControls) {
    quantityControls.forEach(function (control) {
      control.addEventListener('click', function () {
        var productId = control.getAttribute('data-product-id');
        var action = control.getAttribute('data-action');
        var input = document.getElementById('quantity-' + productId);
        var currentQuantity = parseInt(input.value);

        if (action === 'increment') {
          input.value = currentQuantity + 1;
        } else if (action === 'decrement' && currentQuantity > 1) {
          input.value = currentQuantity - 1;
        }

        // Trigger the change event to update the cart on input change
        updateProductQuantity(productId, input.value);
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  CartDrawer();
  handleCartItemActions();
  handleQuantityControls();
});
